import React from "react";
import { Helmet } from "react-helmet";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/June-2026/banner.png";
import jewelleryBrandPartnership from "../../assets/images/Newsletter/June-2026/Our Latest Wins/jewellery-brand-partnership.jpg";
import unifiedCustomerViewFinancialServices from "../../assets/images/Newsletter/June-2026/Our Latest Wins/unified-customer-view-financial-services.jpg";
import sushil from "../../assets/images/Newsletter/images/shushil-Gujrathi.png";
import customerDataPlatformHeritageJewellery from "../../assets/images/Newsletter/June-2026/Our Latest Wins/customer-data-platform-heritage-jewellery.jpg";
import marketingAutomationCoachingInstitute from "../../assets/images/Newsletter/June-2026/Our Latest Wins/marketing-automation-coaching-institute.jpg";
import fireSafetySolutionsDecisionMaking from "../../assets/images/Newsletter/June-2026/Our Latest Wins/fire-safety-solutions-decision-making.jpg";
import omkarDhapte from "../../assets/images/Newsletter/June-2026/omkar-dhapte.png";
import anandDeshpande from "../../assets/images/Newsletter/June-2026/anand-deshpande.png";
import martechAwardAnalytics from "../../assets/images/Newsletter/June-2026/Awards and Recognition/martech-award-marketing-analytics-insight-platform.jpg";
import martechAwardAutomation from "../../assets/images/Newsletter/June-2026/Awards and Recognition/martech-award-marketing-automation-journey-orchestration.jpg";
import martechAwardMobile from "../../assets/images/Newsletter/June-2026/Awards and Recognition/martech-award-mobile-marketing-technology.jpg";
import martechAwardTrophies from "../../assets/images/Newsletter/June-2026/Awards and Recognition/martech-award-trophies.jpg";
import sushilGujrathiGlobal200Leaders from "../../assets/images/Newsletter/June-2026/Awards and Recognition/sushil-gujrathi-global-200-inspirational-leaders.jpg";
import athiraKrishanan from "../../assets/images/Newsletter/June-2026/athira-krishanan.jpg";
import newJoinersQ2 from "../../assets/images/Newsletter/June-2026/new-joiners-q2-2026.png";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import realEstateDeveloperPartnershipExpansion from "../../assets/images/Newsletter/June-2026/Our Latest Wins/real-estate-developer-partnership-expansion.jpg";
import realEstateGroupCustomerEngagementTransformation from "../../assets/images/Newsletter/June-2026/Our Latest Wins/real-estate-group-customer-engagement-transformation.jpg";
import agentforceWorldTourMumbai from "../../assets/images/Newsletter/June-2026/agentforce-world-tour-mumbai.jpeg";
import gtmWorkshopSalesforceSmbLeadershipTeam from "../../assets/images/Newsletter/June-2026/gtm-workshop-salesforce-smb-leadership-team.jpg";
import nasscomGccSummit from "../../assets/images/Newsletter/June-2026/nasscom-gcc-summit.jpeg";
import foundationDayTeam from "../../assets/images/Newsletter/June-2026/Events and Celebrations/foundation-day-team-1.jpg";
import foundationDayCake from "../../assets/images/Newsletter/June-2026/Events and Celebrations/foundation-day-cake-2.jpg";
import chairYogaSession1 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/chair-yoga-session-1.jpg";
import chairYogaSession2 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/chair-yoga-session-2.jpg";
import chairYogaSession3 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/chair-yoga-session-3.jpg";
import chairYogaFelicitation1 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/chair-yoga-session-felicitation-1.jpg";
import chairYogaFelicitation2 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/chair-yoga-session-felicitation-2.jpg";
import funFriday1 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/fun-friday-1.jpg";
import funFriday2 from "../../assets/images/Newsletter/June-2026/Events and Celebrations/fun-friday-2.jpg";
import grandBirthdayCelebrations1 from "../../assets/images/Newsletter/June-2026/grand-birthday-celebrations-1.jpg";
import grandBirthdayCelebrations2 from "../../assets/images/Newsletter/June-2026/grand-birthday-celebrations-2.jpg";
import spiritualCornerChariji from "../../assets/images/Newsletter/June-2026/spiritual-corner-chariji.jpg";
import sundarPichai from "../../assets/images/Newsletter/June-2026/sundar-pichai.jpg";
import leenaNair from "../../assets/images/Newsletter/June-2026/leena-nair.jpg";
import rohitDeshmukh from "../../assets/images/Newsletter/June-2026/rohit-deshmukh.jpg";

const June2026 = () => {
  return (
    <>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        {/* <meta
          property="og:image"
          content="https://www.comsensetechnologies.com/static/media/banner.6e975f755f10acaff87f.png"
        /> */}

        <title>COMSENSE - NEWSLETTER June-2026</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />


        <meta property="og:title" content="March 2026 Newsletter - Comsense Technologies" />
        <meta property="og:description" content="Explore Comsense March 2026 newsletter updates, events, and insights." />
        <meta property="og:image" content="https://www.comsensetechnologies.com/static/media/banner.ac0830962a588290d218.png" />
        <meta property="og:url" content="https://www.comsensetechnologies.com/newsletter/march-2026" />
        <meta property="og:type" content="article" />

        {/* VERY IMPORTANT */}
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* WhatsApp / Twitter support */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      .quote-card-row {\n        display: block !important;\n      }\n\n      .quote-card-text {\n        display: block !important;\n        width: 100% !important;\n        text-align: center !important;\n      }\n\n      .quote-card-gutter {\n        display: none !important;\n      }\n\n      .quote-card-image {\n        display: block !important;\n        width: 100% !important;\n        text-align: center !important;\n        padding-top: 16px !important;\n      }\n\n      .quote-card-image img {\n        margin: 0 auto !important;\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    
                
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sushil}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From The CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                From Harmony to High
                                                Performance: Turning Strategy
                                                into Results
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Team,
                                              <br />
                                              <br />
                                              As we close the second quarter of
                                              2026, I want to take a moment to
                                              reflect on the progress we've
                                              made together. At the beginning
                                              of the year, we spoke about
                                              moving <strong>From Hustle to Harmony,
                                              creating an organization built
                                              not just on hard work, but on
                                              alignment, discipline, and
                                              sustainable growth.</strong> Over the past
                                              quarter, I have been encouraged
                                              to see that vision begin to take
                                              shape across our teams.
                                              <br />
                                              <br />
                                              Q2 has been a quarter of
                                              execution.
                                              <br />
                                              We have strengthened our
                                              leadership rhythm, sharpened our
                                              focus on customer outcomes,
                                              expanded our AI capabilities, and
                                              continued building the
                                              foundations that will enable
                                              Comsense to scale with
                                              confidence. While there is still
                                              much to achieve, we are steadily
                                              evolving from a services
                                              organization into a trusted
                                              transformation partner that
                                              helps clients solve complex
                                              business challenges through
                                              Consulting, Data, AI, Salesforce,
                                              and Engineering.
                                              <br />
                                              <br />
                                              <strong>Our Progress</strong>
                                              <br />
                                              <br />
                                              <strong>People First</strong>
                                              <br />
                                              Great organizations are built by
                                              great people. This quarter, we
                                              invested further in skill
                                              upskilling and development,
                                              capability building, and creating
                                              greater ownership across the
                                              organization. I am particularly
                                              encouraged by the number of
                                              individuals stepping beyond their
                                              defined roles, collaborating
                                              across teams, and taking
                                              accountability for customer
                                              success.
                                              <br />
                                              Our culture is gradually shifting
                                              from "doing assigned work" to
                                              "thinking like business owners."
                                              That mindset will define our
                                              future.
                                              <br />
                                              <br />
                                              <strong>To drive the engagement within
                                              the organization, we have
                                              launched "Vibefy" which is our
                                              Cultural Operating System which
                                              is our core where employee
                                              engagement is strengthened
                                              further</strong>
                                              <br />
                                              <br />
                                              <strong>Customer Impact</strong>
                                              <br />
                                              Our customers continue to place
                                              their trust in us for
                                              business-critical transformation
                                              initiatives. Across every
                                              engagement, our objective remains
                                              unchanged: to create measurable
                                              business outcomes rather than
                                              simply deliver technology. As we
                                              continue to grow, responsiveness,
                                              proactive engagement, and
                                              advisory-led conversations will
                                              become even more important than
                                              execution alone.
                                              <br />
                                              <br />
                                              <strong>
                                                Operational Excellence
                                              </strong>
                                              <br />
                                              Scaling requires consistency.
                                              Throughout Q2, we have continued
                                              strengthening governance,
                                              improving delivery
                                              predictability, standardizing
                                              processes, and introducing
                                              better operational visibility.
                                              These improvements may not
                                              always be visible externally,
                                              but they are essential for
                                              building a company that can grow
                                              without compromising quality.
                                              Every improvement we make today
                                              creates capacity for tomorrow.
                                              <br />
                                              <br />
                                              <strong>
                                                AI as a Differentiator
                                              </strong>
                                              <br />
                                              Artificial Intelligence is
                                              rapidly changing how businesses
                                              operate, and it is changing how
                                              Comsense works as well. This
                                              quarter, we accelerated our
                                              AI-led initiatives across
                                              delivery, consulting, proposal
                                              development, internal
                                              productivity, and solution
                                              innovation. Our objective is not
                                              simply to use AI tools, but to
                                              embed AI into everything we build
                                              and every solution we deliver.
                                              The future belongs to
                                              organizations that combine human
                                              expertise with intelligent
                                              automation, and we are committed
                                              to leading that transformation.
                                              <br />
                                              <br />
                                              <strong>Looking Ahead</strong>
                                              <br />
                                              The second half of 2026 presents
                                              tremendous opportunities. Our
                                              priorities remain clear:
                                              <br />
                                              <br />
                                              • Deepen strategic relationships
                                              with existing customers.
                                              <br />
                                              • Expand our presence in Global
                                              Capability Center (GCC)
                                              programs.
                                              <br />
                                              • Strengthen our consulting-led
                                              approach across every
                                              engagement.
                                              <br />
                                              • Continue investing in
                                              AI-powered offerings and
                                              intellectual property.
                                              <br />
                                              • Build operational excellence
                                              that enables sustainable and
                                              profitable growth.
                                              <br />
                                              <br />
                                              Growth is no longer just about
                                              winning new opportunities. It is
                                              about building lasting customer
                                              relationships, developing
                                              exceptional talent, creating
                                              differentiated capabilities, and
                                              consistently delivering value.
                                              <br />
                                              <br />
                                              If we continue executing with
                                              discipline and remain united
                                              behind our vision, I am confident
                                              that our best chapters are still
                                              ahead.
                                              <br />
                                              <br />
                                              <strong>Thank You</strong>
                                              <br />
                                              <br />

                                              To every member of the Comsense
                                              family, thank you for your
                                              dedication, resilience, and
                                              commitment.

                                              <br />

                                              To our clients, thank you for
                                              your continued trust and
                                              partnership.

                                              <br />

                                              To our partners, thank you for
                                              enabling us to innovate and grow
                                              together.

                                              <br />
                                              <br />
                                              Let us continue building an
                                              organization that is respected
                                              not only for what we deliver,
                                              but for how we deliver
                                              it—with integrity, innovation,
                                              and an unwavering commitment to
                                              excellence.
                                              <br />
                                              Together, let us transform
                                              momentum into sustained success.
                                              <br />
                                              <br />
                                              With gratitude,
                                              <br />
                                              <br />
                                              <strong>Sushil Gujrathi</strong>
                                              <br />
                                              <strong>
                                                Co-Founder & CEO
                                              </strong>
                                              <br />
                                              <strong>
                                                Comsense Technologies
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Our Latest Wins:
                                            </singleline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                  
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense partners with a Trusted Jewellery Brand to Strengthen Customer Engagement 
                                                  </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={jewelleryBrandPartnership}
                                              alt="Comsense partners with a Trusted Jewellery Brand to strengthen customer engagement"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense has partnered with a trusted jewellery brand to provide Salesforce Marketing Cloud Managed Services, helping the business strengthen customer engagement across its growing customer base. The engagement focuses on optimizing campaigns, refining audience segmentation, and delivering more relevant communication across channels. This partnership will support consistent customer experiences while helping the brand build stronger, long-term relationships. 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Enabling a Unified Customer View for a Leading Financial Services Application {" "}
                                                </strong>

                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={unifiedCustomerViewFinancialServices}
                                              alt="Enabling a Unified Customer View for a Leading Financial Services Application"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
As customer expectations continue to evolve in financial services, having a connected view of every interaction is becoming increasingly important. Comsense is implementing a Customer Data Platform for a leading financial services application to unify customer data across touchpoints. The platform will enable richer customer insights, more precise audience segmentation, and timely, personalized engagement, helping the business make better marketing decisions backed by a single source of truth. 

 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Driving Marketing Automation for One of India’s Top Coaching Institute 
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={marketingAutomationCoachingInstitute}
                                              alt="Driving Marketing Automation for One of India's Top Coaching Institute"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense is proud to engage with one of India's leading coaching institutes to implement Salesforce Marketing Cloud, enabling a more connected approach to student communication. From enquiry to enrolment and beyond, the platform will help streamline campaign execution, improve engagement, and deliver more timely and relevant interactions throughout the student journey. 
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Implementing a Customer Data Platform for a Top Heritage Jewellery Brand {" "}
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={customerDataPlatformHeritageJewellery}
                                              alt="Implementing a Customer Data Platform for a Top Heritage Jewellery Brand"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                              For premium jewellery retailers, understanding customer preferences is key to delivering memorable buying experiences. Comsense has partnered with a leading heritage jewellery brand to implement Customer Data Platform, bringing customer information together into a unified view. The implementation will enable stronger audience segmentation, more personalized communication, and data-driven engagement across the customer lifecycle. 

 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Driving Smarter
                                                  Decision-Making for a Leading
                                                  Fire Safety Solutions
                                                  Provider
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={fireSafetySolutionsDecisionMaking}
                                              alt="Driving Smarter Decision-Making for a Leading Fire Safety Solutions Provider"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense is partnering with a
                                                leading fire safety solutions
                                                provider to implement AI
                                                Co-Pilot, helping the
                                                organization transform business
                                                data into meaningful insights.
                                                The solution will provide
                                                faster access to performance
                                                metrics and support informed
                                                decision-making across teams,
                                                enabling the business to
                                                respond with greater agility
                                                while improving visibility into
                                                day-to-day operations.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Expanding Our Partnership
                                                  with a Leading Real Estate
                                                  Developer
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={realEstateDeveloperPartnershipExpansion}
                                              alt="Expanding Our Partnership with a Leading Real Estate Developer"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Building on an existing
                                                Salesforce Data Cloud
                                                engagement, Comsense is
                                                expanding its partnership with
                                                a leading real estate developer
                                                by introducing Tableau
                                                services. The addition of
                                                advanced analytics and
                                                visualization capabilities
                                                will help transform unified
                                                customer data into actionable
                                                business insights, enabling
                                                faster decision-making and a
                                                deeper understanding of
                                                customer trends.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Supporting a Leading Real
                                                  Estate Group with Customer
                                                  Engagement Transformation
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={realEstateGroupCustomerEngagementTransformation}
                                              alt="Supporting a Leading Real Estate Group with Customer Engagement Transformation"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense has partnered with a
                                                leading real estate group to
                                                implement Salesforce Data
                                                Cloud and Salesforce Marketing
                                                Cloud, creating a connected
                                                foundation for customer
                                                engagement. By bringing
                                                together customer data and
                                                marketing automation, the
                                                implementation will enable
                                                more personalized
                                                communication, improved
                                                audience segmentation, and
                                                seamless engagement across the
                                                buyer journey, helping deliver
                                                a more consistent customer
                                                experience.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>


   <tr>
                                  <td height={20} />
                                </tr>


                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

    <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Innovation is imagining the almost possible”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Dr. Anand Deshpande (Founder, Chairman & MD, Persistent Systems)
                                                        </span>{" "}
                                                       
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={anandDeshpande}
                                                      alt="Sundar Pichai, CEO of Alphabet & Google"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={15} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>





          {/* Awards and Recognitions */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Awards and Recognitions
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Recognized with Three
                                            Martech Awards for Driving
                                            Customer Impact
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="70%"
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "180px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={martechAwardAnalytics}
                                                      alt="MarTech Awards 2026 - Excellence in Marketing Analytics & Insight Platform, Royal Enfield India x Comsense Technologies"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "180px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={martechAwardAutomation}
                                                      alt="MarTech Awards 2026 - Excellence in Marketing Automation & Journey Orchestration, Tata Motors Ltd x Comsense Technologies"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={10} colSpan={3} />
                                                </tr>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "180px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={martechAwardMobile}
                                                      alt="MarTech Awards 2026 - Excellence in Mobile Marketing Technology"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "180px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={martechAwardTrophies}
                                                      alt="MarTech Awards 2026 trophies won by Comsense Technologies"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              This quarter, Comsense was
                                              honoured with three MarTech
                                              Awards for delivering impactful
                                              customer engagement solutions
                                              across the automotive sector. The
                                              company received three awards:
                                              <br />
                                              <br />
                                              1){" "}
                                              <strong>
                                                Excellence in the Use of
                                                MarTech in Automotive
                                              </strong>{" "}
                                              for <strong>Royal Enfield India</strong>.
                                              <br />
                                              <br />
                                              2){" "}
                                              <strong>
                                                Excellence in Marketing
                                                Analytics & Insight Platform
                                              </strong>{" "}
                                              with <strong>Royal Enfield India</strong>
                                              <br />
                                              <br />
                                              3){" "}
                                              <strong>
                                                Excellence in Marketing
                                                Automation & Journey
                                                Orchestration
                                              </strong>{" "}
                                              award for{" "}
                                              <strong>Tata Motors Ltd.</strong>
                                              <br />
                                              <br />
                                              These recognitions reflect the
                                              strength of combining data,
                                              technology, and marketing
                                              strategy to create meaningful
                                              customer experiences and
                                              measurable business outcomes.
                                              They also reinforce Comsense's
                                              continued focus on helping
                                              enterprises unlock greater value
                                              through modern marketing
                                              technologies.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Sushil Gujrathi Named Among the
                                            Global 200 Inspirational Leaders Of
                                            2026
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={sushilGujrathiGlobal200Leaders}
                                              alt="Sushil Gujrathi Named Among the Global 200 Inspirational Leaders Of 2026"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense Co-founder and CEO{" "}
                                              <strong>Sushil Gujrathi</strong>{" "}
                                              has been recognised among the{" "}
                                              <strong>
                                                Global 200 Inspirational
                                                Leaders of 2026
                                              </strong>{" "}
                                              in the category of{" "}
                                              <strong>
                                                Data & MarTech Transformation,
                                                Digital Transformation
                                              </strong>
                                              .
                                              <br />
                                              <br />
                                              The recognition celebrates his
                                              contributions to helping
                                              organisations modernise through
                                              AI, analytics, and digital
                                              technologies while aligning
                                              technology with long-term
                                              business goals. Under his
                                              leadership, Comsense continues to
                                              expand its global presence,
                                              delivering data, marketing, and
                                              AI-driven solutions that enable
                                              enterprises to accelerate digital
                                              transformation.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Comsense in Action
                                            </singleline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense at Agentforce World Tour Mumbai 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
The Comsense team attended the Agentforce World Tour at the Jio World Convention Centre in Mumbai, where industry leaders and technology experts discussed the practical impact of AI-powered customer engagement.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={agentforceWorldTourMumbai}
                                              alt="Comsense at Agentforce World Tour Mumbai"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                   
                                    
                                        <tr>
                                          <td height={40} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  GTM Workshop with the
                                                  Salesforce SMB Leadership
                                                  Team
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                gtmWorkshopSalesforceSmbLeadershipTeam
                                              }
                                              alt="GTM Workshop with the Salesforce SMB Leadership Team"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Members of the Comsense
                                                leadership team participated
                                                in a Go-to-Market Workshop
                                                hosted by the{" "}
                                                <strong>
                                                  Salesforce SMB Leadership
                                                  Team
                                                </strong>
                                                .
                                                <br />
                                                <br />
                                                The workshop reinforced the
                                                idea that while technology
                                                continues to evolve,
                                                sustainable growth comes from
                                                solving real business
                                                challenges and creating
                                                lasting value for customers. It
                                                was a valuable opportunity to
                                                exchange perspectives and
                                                strengthen collaboration within
                                                the Salesforce ecosystem.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Nasscom GCC Summit
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={nasscomGccSummit}
                                              alt="Nasscom GCC Summit"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                The Comsense team participated
                                                in the NASSCOM GCC Summit
                                                2026, joining industry
                                                leaders, Global Capability
                                                Centers, and technology
                                                innovators to discuss the
                                                future of enterprise
                                                transformation.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

    
       

          {/*  */}

          <layout label="1/1 content">
            <table
              className="full"
              align="center"
              bgcolor="#333742"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={25} />
                                </tr>

                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Tech Trends 
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{
                                      fontFamily: "Open sans,arial,sans-serif",
                                      fontSize: 18,
                                      color: "red",
                                      lineHeight: "28px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                    }}
                                  >
                                    The Companies That Engineer Intelligence
                                    Will Define the Next Decade
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td>
                                    <table
                                      width={150}
                                      className="table-full"
                                      border={0}
                                      align="left"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              src={omkarDhapte}
                                              width={150}
                                              alt="Omkar Dhapte, Engineering BU Head"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: "5px solid #eaecf0",
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                    <table
                                      width={25}
                                      align="left"
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                      </tbody>
                                    </table>
                                    {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                    <table
                                      className="table-full"
                                      width={375}
                                      border={0}
                                      align="right"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={120} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              border: "0 solid #fff",
                                              borderRadius: 4,
                                            }}
                                          >
                                            <table
                                              width="90%"
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    valign="bottom"
                                                    style={{
                                                      fontFamily:
                                                        "Century gothic,arial,sans-serif",
                                                      fontSize: 24,
                                                      color: "#4a4a4a",
                                                      fontWeight: 100,
                                                      lineHeight: "30px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "#000",
                                                        fontFamily:
                                                          "Century Gothic",
                                                        fontSize: 14,
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "normal",
                                                        marginBottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          color: "#000",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        - Omkar Dhapte,
                                                        Engineering BU Head
                                                      </span>
                                                    </p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td align="left">
                                                    <table
                                                      align="left"
                                                      width={30}
                                                      border={0}
                                                      cellSpacing={0}
                                                      cellPadding={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            height={10}
                                                            style={{
                                                              borderBottom:
                                                                "3px solid red",
                                                            }}
                                                          />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={10} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          

          {/* Tech Trends */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                The Companies That Engineer
                                                Intelligence Will Define the
                                                Next Decade
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              For years, organizations have
                                              measured digital transformation
                                              by the technologies they
                                              adopted: cloud migration, mobile
                                              applications, automation,
                                              analytics, and more recently,
                                              Generative AI. Yet despite
                                              billions invested in technology,
                                              many enterprises still struggle
                                              to create lasting competitive
                                              advantage.
                                              <br />
                                              <br />
                                              Why?
                                              <br />
                                              <br />
                                              Because technology alone has
                                              never been the differentiator.
                                              The ability to engineer
                                              intelligence into the fabric of
                                              a business is.
                                              <br />
                                              <br />
                                              Artificial Intelligence is not
                                              simply another software
                                              capability. It represents a new
                                              operating paradigm that is
                                              fundamentally changing how
                                              businesses make decisions, how
                                              products evolve, and how
                                              engineering organizations create
                                              value.
                                              <br />
                                              <br />
                                              The winners of the next decade
                                              will not be those with the
                                              largest AI budgets or the most
                                              advanced language models. They
                                              will be the organizations that
                                              redesign their products,
                                              processes, and culture around
                                              intelligence.
                                              <br />
                                              <br />
                                              This requires a fundamental shift
                                              in mindset.
                                              <br />
                                              <br />
                                              For decades, enterprise software
                                              was built to execute
                                              instructions. The next generation
                                              of software will understand
                                              context, reason through
                                              complexity, anticipate user
                                              intent, and continuously improve
                                              outcomes. We are moving from
                                              systems of record to systems of
                                              intelligence and ultimately
                                              toward autonomous execution.
                                              <br />
                                              <br />
                                              The real question is no longer,
                                              "How do we use AI?" It is, "How
                                              do we redesign our business
                                              assuming intelligence is
                                              available everywhere?" That
                                              distinction changes everything.
                                              <br />
                                              <br />
                                              Organizations embracing this
                                              transformation will deliver
                                              predictive customer experiences,
                                              self-optimizing operations,
                                              faster product development, and
                                              decisions driven by real-time
                                              intelligence instead of
                                              historical reporting.
                                              <br />
                                              <br />
                                              Another misconception is that AI
                                              will replace engineers.
                                              <br />
                                              <br />
                                              The opposite is more likely.
                                              <br />
                                              <br />
                                              Tomorrow's engineers will spend
                                              less time writing repetitive
                                              code and more time designing
                                              resilient architectures,
                                              orchestrating intelligent
                                              systems, governing AI behaviour,
                                              and solving complex business
                                              problems. Engineering excellence
                                              will increasingly be measured by
                                              the intelligence, resilience,
                                              and business impact of the
                                              systems delivered.
                                              <br />
                                              <br />
                                              At Comsense, AI is not viewed as
                                              a standalone capability but as a
                                              force multiplier across
                                              enterprise technology. From
                                              customer data platforms and
                                              workflow automation to real-time
                                              analytics and intelligent
                                              decision engines, the focus is
                                              on building platforms that help
                                              organizations move faster, make
                                              smarter decisions, and create
                                              measurable value.
                                              <br />
                                              <br />
                                              Every generation of technology
                                              creates a defining moment.
                                              <br />
                                              <br />
                                              Cloud rewarded scalability.
                                              <br />
                                              <br />
                                              Mobile rewarded customer
                                              experience.
                                              <br />
                                              <br />
                                              Data rewarded measurement.
                                              <br />
                                              <br />
                                              Artificial Intelligence will
                                              reward those who learn to
                                              engineer intelligence itself.
                                              <br />
                                              <br />
                                              The future will not be defined
                                              by AI alone. It will be shaped
                                              by the engineers, product
                                              leaders, and organizations bold
                                              enough to redefine what
                                              technology can achieve.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={60} />
                                        </tr>
                                        
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

           <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “It's a long road.
                                                        Setbacks don't
                                                        actually matter”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Sundar Pichai
                                                        </span>{" "}
                                                        (CEO of Alphabet &
                                                        Google)
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={sundarPichai}
                                                      alt="Sundar Pichai, CEO of Alphabet & Google"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={15} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

    

          {/* Associate Speak */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Voices of Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td align="center">

                                            <table
                                              className="table-inner"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                            }}
                                                          >
                                                            <img
                                                              src={rohitDeshmukh}
                                                              alt="Rohit Deshmukh, Salesforce Associate"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Joining Comsense
                                                              Technologies has
                                                              been a journey of
                                                              new opportunities,
                                                              continuous
                                                              learning, and
                                                              growth. I started
                                                              here as a Senior
                                                              Marketing
                                                              Manager, working
                                                              on GTM strategies
                                                              and digital
                                                              initiatives for
                                                              renowned brands
                                                              and clients. Over
                                                              time, I was given
                                                              the opportunity
                                                              to transition
                                                              into the
                                                              Salesforce
                                                              ecosystem and
                                                              work on
                                                              technologies such
                                                              as Sales Cloud,
                                                              Service Cloud,
                                                              Agentforce, and
                                                              Headless 360. The
                                                              journey has been
                                                              filled with
                                                              exciting
                                                              challenges and
                                                              experiences that
                                                              have helped me
                                                              expand my skills
                                                              and explore an
                                                              entirely new
                                                              technology
                                                              landscape.
                                                              <br />
                                                              <br />
                                                              One of the things
                                                              I value most
                                                              about Comsense is
                                                              the freedom to
                                                              learn,
                                                              experiment, and
                                                              take ownership
                                                              beyond defined
                                                              roles. The
                                                              collaborative
                                                              environment,
                                                              support from
                                                              leadership and
                                                              colleagues, along
                                                              with initiatives
                                                              like Fun Fridays,
                                                              tech events, and
                                                              cultural
                                                              activities, make
                                                              it a place where
                                                              work and growth
                                                              go hand in hand.
                                                              I'm proud to be
                                                              part of a team
                                                              that continuously
                                                              encourages
                                                              learning and
                                                              embraces new
                                                              ideas.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Rohit
                                                                  Deshmukh,
                                                                </strong>{" "}
                                                                Salesforce
                                                                Associate
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>



                                            <table
                                              className="table-inner desktop-view"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              an excellent
                                                              place for
                                                              continuous
                                                              learning and
                                                              professional
                                                              growth. What I
                                                              value most is the
                                                              supportive team
                                                              and the
                                                              collaborative
                                                              work culture. The
                                                              guidance and
                                                              encouragement
                                                              from our
                                                              leadership
                                                              inspire us to
                                                              learn, take on
                                                              new challenges,
                                                              and keep
                                                              improving.
                                                              <br />
                                                              <br />
                                                              The open and
                                                              inclusive culture
                                                              at Comsense
                                                              allows us to
                                                              connect with
                                                              different teams,
                                                              share ideas, and
                                                              explore new
                                                              opportunities
                                                              without
                                                              limitations.
                                                              This environment
                                                              has helped me
                                                              grow both
                                                              personally and
                                                              professionally.
                                                              <br />
                                                              <br />
                                                              More than just a
                                                              workplace,
                                                              Comsense feels
                                                              like a family
                                                              where everyone is
                                                              valued and
                                                              supported. I am
                                                              proud to be a
                                                              part of Comsense
                                                              and truly
                                                              grateful for the
                                                              opportunity to
                                                              contribute to its
                                                              journey.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Athira
                                                                  Krishanan,
                                                                </strong>{" "}
                                                                MarTech
                                                                Associate
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={30} />
                                                        </tr>
                                                        <tr>
                                                          <td height={5} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={athiraKrishanan}
                                                              alt="Athira Krishanan, MarTech Associate"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={45} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner mobile-responsive"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={athiraKrishanan}
                                                              alt="Athira Krishanan, MarTech Associate"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              an excellent
                                                              place for
                                                              continuous
                                                              learning and
                                                              professional
                                                              growth. What I
                                                              value most is the
                                                              supportive team
                                                              and the
                                                              collaborative
                                                              work culture. The
                                                              guidance and
                                                              encouragement
                                                              from our
                                                              leadership
                                                              inspire us to
                                                              learn, take on
                                                              new challenges,
                                                              and keep
                                                              improving.
                                                              <br />
                                                              <br />
                                                              The open and
                                                              inclusive culture
                                                              at Comsense
                                                              allows us to
                                                              connect with
                                                              different teams,
                                                              share ideas, and
                                                              explore new
                                                              opportunities
                                                              without
                                                              limitations.
                                                              This environment
                                                              has helped me
                                                              grow both
                                                              personally and
                                                              professionally.
                                                              <br />
                                                              <br />
                                                              More than just a
                                                              workplace,
                                                              Comsense feels
                                                              like a family
                                                              where everyone is
                                                              valued and
                                                              supported. I am
                                                              proud to be a
                                                              part of Comsense
                                                              and truly
                                                              grateful for the
                                                              opportunity to
                                                              contribute to its
                                                              journey.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Athira
                                                                  Krishanan,
                                                                </strong>
                                                                {""} MarTech
                                                                Associate
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>


                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td align="center"></td>
                                                </tr>
                                                
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


           <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Put your hand up for the most difficult job… lean into things that are challenging, because that's what gives you the greatest credibility, respect, and reputation as you build your career.”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Leena Nair (CEO, Chanel)
                                                        </span>{" "}
                                                       
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={leenaNair}
                                                      alt="Leena Nair, CEO, Chanel"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={35} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

  

          
          {/* Welcome Aboard */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Last quarter marked another
                                              exciting phase of growth for
                                              Comsense Technologies as we
                                              welcomed new members to our
                                              company.
                                              <br />
                                              <br />
                                              We are thrilled to have them
                                              with us and look forward to
                                              achieving great things together.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={newJoinersQ2}
                                              alt="Welcome Aboard - New joiners at Comsense Technologies: Sony Petkar, Pranjali Gujar, Saurabh Wabale, Tijo Varughese, Bishlesha Khandelwal, Kanchan Yadav, Devendra Kathar, Pragati Golhar, Snehal Gulhane, Priyanka Devi"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={40} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Events and Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Events & Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Celebrating Comsense's Foundation
                                            Day
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={foundationDayTeam}
                                                      alt="Celebrating Comsense's Foundation Day - team celebration"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={foundationDayCake}
                                                      alt="Celebrating 11 years of Excellence - Foundation Day cake"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Celebrated 11 years of Comsense
                                              Technologies on our Foundation
                                              Day, a reminder of how far we
                                              have come.
                                              <br />
                                              <br />
                                              We marked the day with a
                                              sumptuous team lunch, filled with
                                              conversations and laughter,
                                              followed by a cake cutting and
                                              stories that have shaped this
                                              journey.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Chair Yoga Session
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="32%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "150px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={chairYogaSession1}
                                                      alt="Chair Yoga Session at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="32%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "150px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={chairYogaSession2}
                                                      alt="Chair Yoga Session at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="32%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "150px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={chairYogaSession3}
                                                      alt="Chair Yoga Session at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="70%"
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={chairYogaFelicitation1}
                                                      alt="Felicitating the Chair Yoga Session instructors"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={chairYogaFelicitation2}
                                                      alt="Felicitating the Chair Yoga Session instructors"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              To mark International Yoga Day,
                                              the Comsense team participated in
                                              a chair yoga session led by{" "}
                                              <strong>Anoushka Rajebhosale</strong>{" "}
                                              and <strong>Priti Shinde</strong>{" "}
                                              from Primal Yoga. The session
                                              encouraged everyone to pause,
                                              recharge, and embrace simple
                                              wellness practices that promote
                                              balance and well-being in the
                                              workplace.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Fun Fridays
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={funFriday1}
                                                      alt="Fun Fridays at Comsense"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={funFriday2}
                                                      alt="Fun Fridays at Comsense"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our Fun Fridays continue to be a
                                              great way to wrap up the week.
                                              Through interactive games and
                                              light-hearted activities, teams
                                              came together to unwind,
                                              connect, and enjoy time beyond
                                              work, strengthening the sense of
                                              camaraderie that defines life at
                                              Comsense.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Grand Birthday Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Grand Birthday Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="70%"
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={
                                                        grandBirthdayCelebrations1
                                                      }
                                                      alt="Grand Birthday Celebrations at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={
                                                        grandBirthdayCelebrations2
                                                      }
                                                      alt="Grand Birthday Celebrations at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Birthdays are reasons for
                                              special celebrations. The
                                              previous quarter was fun filled
                                              as we celebrated birthdays of:
                                              <br />
                                              <br />
                                              Aniket Neurgaonkar, Uddhav
                                              Solanke, Sumedh Pawaskar, Rutika
                                              Bhikule, Saurav Patil, Shraddha
                                              Kale, Anant Kadam, Shivkumar
                                              Dusad, Pravish Acharya, Rishabh
                                              Manchanda, Soumy Dubey, Linal
                                              Patil, Shreyash Pole, Suraj
                                              Patil, Vedant Raibole, Juhi Shah,
                                              Harshwardhan Wadekar, Aditya
                                              Agrelwar, Sneha Singh, Akshita
                                              Jain, Pruthviraj Gaikwad, Kavita
                                              Dave, Bishlesha Khandelwal,
                                              Kanchan Yadav, Tijo Varughese,
                                              Pranjali Gujar, Snehal Gulhane,
                                              Pragati Golhar, Priyanka Devi,
                                              Devendra Kathar, Saurabh Wabale.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


          {/* Spiritual Corner */}
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Spiritual Corner
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={300}
                                      className="table-full"
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                           <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={spiritualCornerChariji}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                     
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 16,
                                      color: "#9b9b9b",
                                      lineHeight: "28px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    <multiline label="quote">
                                      <i>
                                        “Everything that is worth doing is
                                        worth doing when we are young,
                                        including meditation.”
                                      </i>{" "}
                                      - Chariji
                                    </multiline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "22px",
                                    }}
                                  >
                                    <multiline label="content">
                                      <a
                                        href="https://heartfulness.org/ca/chariji/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "#9b9b9b",
                                          fontFamily: "Open Sans",
                                          fontSize: 14,
                                          fontWeight: 700,
                                          lineHeight: "22px",
                                          textDecorationLine: "underline",
                                        }}
                                      >
                                        Heartfulness Guide Chariji (1927-2014)
                                      </a>
                                      <br />
                                      <i>
                                        Learn more about Heart-based
                                        meditation at{" "}
                                        <a
                                          href="https://www.heartfulness.org/"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#9b9b9b",
                                            fontFamily: "Open Sans",
                                            fontSize: 14,
                                            fontWeight: 700,
                                            lineHeight: "22px",
                                            textDecorationLine: "underline",
                                          }}
                                        >
                                          www.heartfulness.org
                                        </a>
                                      </i>
                                    </multiline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                 <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

        
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default June2026;
